import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/failed.png'


const _hoisted_1 = { class: "container container--slim step-thx-page step-thx-page--payed" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-80",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "container__subheader t-center t-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.subheader`)) + " ", 1),
      _hoisted_4,
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.email`)) + " ", 1),
      _hoisted_6,
      _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phone`)), 1)
    ])
  ]))
}